import { render, staticRenderFns } from "./News-list.vue?vue&type=template&id=aac165dc&scoped=true&"
import script from "./News-list.vue?vue&type=script&lang=ts&"
export * from "./News-list.vue?vue&type=script&lang=ts&"
import style0 from "./News-list.vue?vue&type=style&index=0&id=aac165dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac165dc",
  null
  
)

export default component.exports